<template>
    <img :src="pic" :alt="alt" :title="title" :class="className"/>
</template>
<script>
const cache = new Map();
export default {
  name: 'SecureImage',
  props: {
    src: String,
    alt: String,
    title: String,
    className: String,
  },
  data() {
    return {
      pic: undefined,
    }
  },
  mounted() {
    this.retrievePic();
  },
  methods: {
    retrievePic() {
      if (cache.has(this.src)) {
        this.pic = cache.get(this.src);
        return
      }

      const params = { responseType: 'arraybuffer' }; // or { responseType: 'blob' }
      this.$http.get(this.src, params)
        .then(
          response => {
            const blob = new Blob([response.body], {type: "text/pdf;charset=utf-8"}); // or {type: 'application/pdf'}
            this.pic = URL.createObjectURL(blob);
            cache.set(this.src, this.pic);
          },
          response => {
            this.pic = undefined;
            console.log('Fail', response);
          });
    },
  }
}
</script>
<style>

</style>
